<enelx-navbar productName="FDR PAST PERFORMANCE" [url]="navbarUrl" position="left" [maxMenuElements]="0">
  <div slot="content">
    @if (!rolesLoaded()) {
      <div class="app-loading">
        <dsy-loader type="spinner" size="xx-small" animation-speed="slow"></dsy-loader>
      </div>
    }
    <router-outlet />
    <ngx-global-contact-footer class="footer"></ngx-global-contact-footer>
  </div>
</enelx-navbar>
